<template>
  <card
    :key="fieldGroup"
    :title="trans(`aspects.${aspect}.forms.field-groups.names.${fieldGroup}`)"
    :options="{ style: { card: 'margin-bottom: 1rem;' } }"
    class="mb-3"
  >
    <template v-if="Object.keys(columns).length > 0">
      <div v-for="(fieldType, column) in columns" :key="column" class="row">
        <div :class="'pe-1 col' + (fieldGroup === 'custom' || fieldGroup === 'non-atomic' ? '-2' : '-4')">
          <strong>{{
            trans(`models.${resourceType}.` + (fieldType !== 'belongs-to' ? 'attributes' : 'relations') + `.${column}`)
          }}</strong
          >:
        </div>
        <div :class="'ps-1 col' + (fieldGroup === 'custom' || fieldGroup === 'non-atomic' ? '-10' : '-8')">
          <presentation-field
            :element="getElement(column, 'display', meta)"
            :column="column"
            :column-type="meta.elementTypes[column]"
            :mutation="meta.mutations[column]"
            :meta="meta"
            :resource-type="resourceType"
            :value="model.data.attributes[column] ?? model.data.relations[column]"
            :show-id="$page.props.user.roles.includes('tech')"
            @add-toast="$emit('addToast')"
          ></presentation-field>
        </div>
      </div>
    </template>
  </card>
</template>

<script>
import PresentationField from '@kanrisha/components/Presentation/PresentationField';
import useResource from '@kanrisha/composables/useResource';
import Card from '@kanrisha/components/Base/Card';

export default {
  components: {
    Card,
    PresentationField,
  },
  props: {
    model: {
      type: Object,
      default: () => {},
    },
    columns: {
      type: Object,
      default: () => {},
    },
    fieldGroup: { type: String, default: '' },
  },
  emits: ['addToast'],
  setup(props) {
    const { meta, resourceType, getElement } = useResource(props, props.model);

    return { meta, resourceType, getElement };
  },
};
</script>
